import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TestActionsService} from '../../services/test-actions.service';
import {DynamicModalLoaderService} from '../../../../layout/services/dynamic-modal-loader.service';
import {ConfirmModalComponent} from '../../../../layout/components/modals/confirm-modal/confirm-modal.component';
import {modalResponse} from '../../../../layout/constants/modal-responses.enum';
import {RouterManagerService} from "@ispm/core/services/router-manager.service";


@Component({
  selector: 'gen-qms-section',
  templateUrl: './qms-section.component.html',
  styleUrls: ['./qms-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class QmsSectionComponent implements OnInit {
  @Output() statusUpdate: EventEmitter<number> = new EventEmitter();
  @Input() testNumber: string;
  @Input() status: number;
  @Input() diagnosticOrderId: string;
  @Input() alerts = [];

  constructor(private testActions: TestActionsService,
              private modalLoader: DynamicModalLoaderService,
              private routerManagerService: RouterManagerService) {
  }

  ngOnInit() {
    this.testActions.getAlerts(this.diagnosticOrderId).subscribe((alerts) => {
      this.alerts = alerts;
      if (alerts.length === 0) {
        this.status = 0;
      }
      else {
        this.status = alerts.filter(alert => alert.alert).length > 0 ? 1 : 2;
      }
      this.statusUpdate.emit(this.status);
    });

  }

  updateNonConformanceStatus() {
    const ids = this.alerts.filter(alert => alert.alert).map(alert => alert.id);
    if (!(ids && ids.length > 0)) { return; }
    const alertText = ids.length > 1 ? 'alerts' : 'alert';
    this.modalLoader.popupModal(ConfirmModalComponent,
      {
        title: `Are you sure you want to clear ${ids.length} ${alertText}?`,
        content: '',
        approveBtn: 'Clear',
        declineBtn: 'Cancel'
      })
      .filter(response => response.payload)
      .map(response => response.payload)
      .filter((response: modalResponse) => response === modalResponse.approve)
      .flatMap(() => this.testActions.updateNonConformanceStatus(this.routerManagerService.parameters.testId, this.routerManagerService.parameters.revisionId, ids))
      .subscribe((response) => {
        this.status = 2;
        this.statusUpdate.emit(this.status);
      });

  }

  openQms() {
    this.testActions.openQMS(this.testNumber);
  }

}
